import React from 'react';
import { Button } from '@mui/material';

import CallIdentity from 'components/CallScribe/Dialer/CallIdentity';
import PopupLaunchSteps from 'components/CallScribe/PopupLaunchSteps';
import {
  calleeLabel,
  formattedNumber,
  readPopupCallContext,
} from 'components/CallScribe/popupCallContext';
import usePopupCallViewStyles from 'components/CallScribe/popupCallViewStyles';

const NO_FALLBACK = { crmSourceId: null, externalTicketId: null };

const PopupSigningIn: React.FC = () => {
  const classes = usePopupCallViewStyles();
  const context = readPopupCallContext(window.location.search, NO_FALLBACK);
  const callee = calleeLabel(context) || 'the number you picked';

  return (
    <div className={classes.root}>
      <div className={classes.stage}>
        <CallIdentity
          name={callee}
          status="Signing you in…"
          tone="pending"
          inputVolume={0}
          outputVolume={0}
          ringActive={false}
        />
        <PopupLaunchSteps
          stage="signing-in"
          callee={callee}
          number={formattedNumber(context.toNumber)}
        />
        <Button
          variant="text"
          className={classes.quietButton}
          onClick={() => { window.close(); }}
        >
          Cancel
        </Button>
      </div>
    </div>
  );
};

export default PopupSigningIn;
